module.exports = __webpack_public_path__ + "static/media/tablet.968c87fc.png";